import type { StoreAuditGlobalState } from '../../models';

export const STORE_AUDIT_SLICE_NAME: string = 'storeAudit';

export const INIT_STORE_AUDIT_STATE: StoreAuditGlobalState = [];
